import { IPatient, TypesPatient } from "@context/types/patient";
import { GlobalAction } from "@context/types";
export const patientReducer = (state: IPatient, action: GlobalAction) => {
  switch (action.type) {
    case TypesPatient.Save:
      return {
        ...action.payload,
      };
    case TypesPatient.Reset:
      return {
        country: "",
        state: "",
        city: "",
        streetName: null,
        neighborhood: null,
        address: null,
        addressDetail: null,
        phone: null,
        email: null,
        means: null,
        natural: {
          name: null,
          lastName: null,
          bond: null,
          docType: null,
          documemt: null,
          relationshipType: null,
          relationship: null,
        },
        legal: { entity: null, entityType: null },
      };

    default:
      return state;
  }
};
